import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/add',
    name: "addQuestion",
    component: () => import('../views/addQuestions.vue')
  },
  {
    path: '/user/:id',
    name: "ExameList",
    component: () => import('../views/user/exameList.vue')
  },
  {
    path: '/questions/:id',
    name: 'questions',
    component: () => import('../views/user/questionsList.vue')
  },
  // {
  //   path: '/dash',
  //   name: 'Dash',
  //   component: () => import('../views/admin/adminDash.vue')
  // },
  {
    path: '/photos',
    name: 'Photo',
    component: () => import('../views/admin/photo.vue')
  },
  {
    path: '/editExame/:id',
    name: 'EditExame',
    component: () => import('../views/admin/editexame.vue')
    , props: true
  },
  {
    path: '/edit/:id',
    name: "editingText",
    component: () => import('../views/editText.vue')
  },
  {
    path: '/Exame/:id',
    name: "TextPage",
    component: () => import('../views/TextPage.vue'),
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
